import AuthService from '../../clawjs/components/AuthService';

class Download extends AuthService {

    /**
     * INIT API
     */

    preinitialize() {
        super.preinitialize("download");
    }
    
    /**
     * PROTECTED
     */

    getDefaultOptions() {
        return {
            api: "/download"
        }
    }

    getMap() {
        return {
            getLink: { path: "/link", method: "post" }
        }
    }
}

export default Download;